import { AutocompleteWithLabel } from '@adotel/components'
import { LazyQueryExecFunction, OperationVariables } from '@apollo/client'
import { Button } from '@material-ui/core'
import { useEffect } from 'react'

import { DateObject } from '../../helpers/date'
import { getTranslate } from '../../localization'
import { Channel } from '../../types/channel'
import {
  AllocatedData,
  AllocatedListInput
} from '../../types/inventoryAllocatedList'
import { RoomTypeBrief } from '../../types/roomtype'
import useStyles from './styles/AllocateFilterBox.styles'

interface AllocateFilterBoxProps {
  accommodation: any
  roomTypeValue: any
  setRoomTypeValue: React.Dispatch<any>
  channelValue: any
  setChannelValue: React.Dispatch<any>
  roomTypeData:
    | {
        roomTypes: RoomTypeBrief[]
      }
    | undefined
  loadingForRoomType: boolean
  getRoomTypes: LazyQueryExecFunction<
    {
      roomTypes: RoomTypeBrief[]
    },
    OperationVariables
  >
  channelsData: Channel[] | undefined
  loadingForChannel: boolean
  dateObject: DateObject
  getAllocatedList: LazyQueryExecFunction<
    {
      allocatedList: AllocatedData
    },
    OperationVariables
  >
  input: AllocatedListInput
  setinput: React.Dispatch<React.SetStateAction<AllocatedListInput>>
}

const AllocateFilterBox: React.FC<AllocateFilterBoxProps> = ({
  accommodation,
  roomTypeValue,
  setRoomTypeValue,
  channelValue,
  setChannelValue,
  roomTypeData,
  loadingForRoomType,
  getRoomTypes,
  channelsData,
  loadingForChannel,
  dateObject,
  getAllocatedList,
  input,
  setinput
}) => {
  const classes = useStyles()

  useEffect(() => {
    if (accommodation && accommodation.value) {
      getRoomTypes({
        variables: {
          propertyCode: accommodation.code,
          showDeletedRoomTypes: false,
          showDeactivedRoomTypes: false
        }
      })
      getAllocatedList({
        variables: {
          input: input
        }
      })
    }
  }, [accommodation && accommodation.value, dateObject])

  const handleClickOnFilterButton = () => {
    getAllocatedList({
      variables: {
        input: input
      }
    })
  }

  return (
    <div className={classes.root}>
      <div className={classes.upSection}>
        <div className={classes.upLeftSide}>
          <AutocompleteWithLabel
            placeholder={getTranslate('choose roomtype')}
            value={roomTypeValue}
            label={getTranslate('RoomType')}
            options={
              roomTypeData?.roomTypes.map((item) => ({
                label: item.name,
                value: item.id || '',
                code: item.displayRoomTypeCode || ''
              })) || []
            }
            onChange={(_, v: any) => {
              if (v) {
                setRoomTypeValue(v)

                setinput({
                  ...input,
                  roomTypeCode: v.code
                })
              } else {
                setRoomTypeValue(null)

                setinput({
                  ...input,
                  roomTypeCode: undefined
                })
              }
            }}
            noHelperText
            getOptionLabel={(option) => option.label || ''}
            getOptionSelected={(option, value) => option.value === value.value}
            inputSize="small"
            loading={loadingForRoomType}
            loadingText={getTranslate('Loading') + '...'}
          />
          <AutocompleteWithLabel
            placeholder={getTranslate('Choose Channel')}
            value={channelValue}
            label={getTranslate('Channel')}
            options={
              (channelsData &&
                channelsData.map((item) => ({
                  label: item.basicDetails.name,
                  value: item.basicDetails.channelID || ''
                }))) ||
              []
            }
            onChange={(_, v: any) => {
              if (v) {
                setChannelValue(v)

                setinput({
                  ...input,
                  channelID: v.value
                })
              } else {
                setChannelValue(null)

                setinput({
                  ...input,
                  channelID: ''
                })
              }
            }}
            noHelperText
            getOptionLabel={(option) => option.label || ''}
            getOptionSelected={(option, value) => option.value === value.value}
            inputSize="small"
            loading={loadingForChannel}
            loadingText={getTranslate('Loading') + '...'}
          />
        </div>
      </div>
      <div className={classes.downSection}>
        <Button
          onClick={handleClickOnFilterButton}
          className={classes.filterButton}
          variant="contained"
          color="primary">
          {getTranslate('Filter')}
        </Button>
        <Button
          onClick={() => {
            setChannelValue({})
            setRoomTypeValue({})
          }}
          className={classes.resetFilterButton}
          variant="contained"
          color="primary">
          {getTranslate('Reset Filter')}
        </Button>
      </div>
    </div>
  )
}

export default AllocateFilterBox
